import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion'; 
import { Home } from 'lucide-react';

export default function OrderSuccess({ orderData }) {
  const { 
    reference = "#PENDING", 
    date = new Date().toLocaleDateString(), 
    responseTime = "Within 24 hours" 
  } = orderData || {};

  return (
    <motion.div 
      
      initial={{ opacity: 0, x: 20 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -20 }}
      transition={{ duration: 0.5 }}
      className="min-h-screen flex flex-col justify-between bg-linear-to-b from-gray-100 via-green-100 to-green-700"
    >
      <header className="px-6 py-8 w-full">
        <h1 className="text-2xl font-bold text-black">FINCA</h1>
      </header>

      <main className="grow flex flex-col items-center px-8 justify-center text-center max-w-md mx-auto w-full">
        
        {/* Success Ico */}
        <motion.div 
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ type: "spring", stiffness: 260, damping: 20, delay: 0.2 }}
          className="relative h-24 w-24 bg-black rounded-full flex items-center justify-center mb-16 shadow-2xl"
        >
          <span className="text-6xl">🎉</span>
          <div className="absolute -top-2 -right-2 text-2xl animate-pulse">✨</div>
        </motion.div>

        <motion.h2 
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
          className="text-2xl text-gray-900 mb-4 font-bold"
        >
          Order Received!
        </motion.h2>
        
        <motion.p 
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4 }}
          className="text-gray-800 text-sm md:text-base font-medium mb-8 leading-relaxed"
        >
          Thank you for reaching out! We've received your message and our team will get back to you within 24 hours.
        </motion.p>

        {/* Info Card */}
        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5, type: "spring", stiffness: 100 }}
          className="bg-white px-8 w-full rounded-3xl p-8 text-left mb-10 border border-gray-200 shadow-lg"
        >
          <div className="space-y-4">
            <div>
              <p className="text-black font-bold text-lg">Reference Number</p>
              <p className="text-gray-600 font-medium uppercase">{reference}</p>
            </div>
            
            <div>
              <p className="text-black font-bold text-lg">Date</p>
              <p className="text-gray-600 font-medium">{date}</p>
            </div>

            <div>
              <p className="text-black font-bold text-lg">Expected Response</p>
              <p className="text-gray-600 font-medium">{responseTime}</p>
            </div>

            <p className="text-gray-700 text-sm pt-2 border-t border-gray-100">
              A confirmation email has been sent to your email address with all the details.
            </p>
          </div>
        </motion.div>

        {/* Home Button */}
        <Link to="/">
          <motion.button 
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="bg-black text-white px-8 py-4 rounded-full flex items-center gap-3 mb-12 shadow-2xl hover:bg-green-900 transition-colors active:scale-95 cursor-pointer"
          >
            <Home size={20} />
            <span className="font-bold">Back To Home</span>
          </motion.button>
        </Link>
      </main>

      <footer className="px-6 py-6 text-center">
        <p className="text-white opacity-80 text-sm">
          Copyright © 2025 AADA. All rights reserved.
        </p>
      </footer>
    </motion.div>
  );
}